<div class='row'>
  @if (occupation?.occupationType; as type) {
    <div class='col-md-4'>
      <app-label label='Rodzaj:'>
        {{ type | occupationType: roadOccupationTypes() }}
      </app-label>
    </div>
  }
  @if (occupation?.surfaceViolation; as surfaceViolation) {
    <div class='col-md-4'>
      <app-label label='Rodzaj:'>
        {{ surfaceViolation }}
      </app-label>
    </div>
  }
  @if (occupation?.city; as city) {
    <div class='col-md-6'>
      <app-label label='Miejscowość:'>
        {{ city }}
      </app-label>
    </div>
  }
  @if (occupation?.workPurpose; as workPurpose) {
    <div class='col-12'>
      <app-label label='Cel prowadzenia robót:'>
        {{ workPurpose }}
      </app-label>
    </div>
  }
  @if (occupation?.purpose; as purpose) {
    <div class='col-12'>
      <app-label label='Cel zajęcia:'>
        {{ purpose }}
      </app-label>
    </div>
  }
  @if (occupation?.typeOfFailure; as typeOfFailure) {
    <div class='col-md-8'>
      <app-label label='Rodzaj awarii:'>
        {{ typeOfFailure }}
      </app-label>
    </div>
  }
</div>
<br>
@if (occupation?.locationDecisions; as locationDecisions) {
  @if (showLocationDecisions) {
    <dl>
      <dt class="mb-3">
        <strong>
          Decyzje
        </strong>
      </dt>
      <dd>
        <app-location-decisions-preview
          [locationDecisions]="locationDecisions || []">
        </app-location-decisions-preview>
      </dd>
    </dl>
    <br>
  }
}
<dl>
  <dt class="mb-3">
    <strong>Etapy</strong>
  </dt>
  <dd>
    <ol>
      @for (stage of occupation?.stages; track $index) {
        <li>
          <div class='row'>
            <div class='col-md-4'>
              <app-label label='Data od:'>
                {{ stage?.startDate | date }}
              </app-label>
            </div>
            <div class='col-md-4'>
              <app-label label='Data do:'>
                {{ stage?.endDate | date }}
              </app-label>
            </div>
            <div class="col-md-4">
              <app-label label="Ilość dni:">
                {{ stage.dayQuantity }}
              </app-label>
            </div>
            <div class='col-md-4'>
              <app-label label='Geometria:'>
                {{ stage?.geometry ? 'Tak' : 'Nie' }}
              </app-label>
            </div>
          </div>
          <div class="row">
            <div class="col-md-4">
              <app-label label="Numer drogi:">
                {{ stage.roadNumber || '-' }}
              </app-label>
            </div>
            <div class="col-md-4">
              <app-label label="Nazwa drogi:">
                {{ stage.roadName || '-' }}
              </app-label>
            </div>
            <div class="col-md-4">
              <app-label label="Ulica:">
                {{ stage.street || '-' }}
              </app-label>
            </div>
          </div>
          <br>
          <div class="row">
            <div class="col-12">
              <p class="mb-2">
                <strong>
                  Działki
                </strong>
              </p>
              <app-parcels-preview [parcels]="stage.parcels">
              </app-parcels-preview>
              <br>
            </div>
          </div>
          <app-road-occupation-stage-table [stage]='stage'>
          </app-road-occupation-stage-table>
        </li>
        @if (!$last) {
          <hr>
        }
      }
    </ol>
  </dd>
</dl>

